module.exports = __webpack_public_path__ + "static/img/can-bellini-bliss.e558561.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cans/can-bellini-bliss.png
// module id = 9iLV
// module chunks = 0